module.exports = __webpack_public_path__ + "img/monkey.9cf45058.svg";